import { ActionTypes } from 'constants/index'

export const getPowerBiReport = (fields) => dispatch => {
	return dispatch({ type: ActionTypes.GET_POWER_BI_REPORT, payload: fields })
}

export const clearPowerBiState = () => dispatch => {
	return dispatch({ type: ActionTypes.CLEAR_POWER_BI_STATE })
}